import { Col, Row } from "antd";
import { InputStyle } from "../constants";
import InputComponent from "../../../components/InputComponent";
import SelectComponent from "../../../components/SelectComponent";
import { useMobileAppVersionContext } from "../../../context/MobileAppVersionContext/MobileAppVersionContext";
import type React from "react";
import { APP_OPTIONS, PLATFORM_OPTIONS } from "./constants";

const GeneralInfo = () => {
	const { mobileAppVersionData, setMobileAppVersionData } = useMobileAppVersionContext();

	const handlePlatformChange = (value: string) => {
		setMobileAppVersionData({ ...mobileAppVersionData, platform: value });
	};

	const handleAppChange = (value: string) => {
		setMobileAppVersionData({ ...mobileAppVersionData, appId: Number(value) });
	};

	const handleVersionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setMobileAppVersionData({ ...mobileAppVersionData, version: e.target.value });
	};

	return (
		<>
			<Row gutter={20}>
				<Col span={12}>
					<InputComponent
						title="Sürüm No"
						placeholder="Örn: 1.0.0"
						isRequired
						style={InputStyle}
						value={mobileAppVersionData?.version}
						onChange={handleVersionChange}
					/>
				</Col>
			</Row>
			<Row gutter={20}>
				<Col span={10}>
					<SelectComponent
						title="Uygulama"
						placeholder="Uygulama seçiniz"
						options={APP_OPTIONS}
						value={mobileAppVersionData?.appId?.toString() || undefined}
						onChange={handleAppChange}
						isRequired
					/>
				</Col>
				<Col span={10}>
					<SelectComponent
						title="Platform"
						placeholder="Platform seçiniz"
						options={PLATFORM_OPTIONS}
						value={mobileAppVersionData?.platform || undefined}
						onChange={handlePlatformChange}
						isRequired
					/>
				</Col>
			</Row>
		</>
	);
};

export default GeneralInfo;
